export default __webpack_public_path__ + "static/media/nonotification.3a8f8064.svg";